import atom from './atom.svg';
import statom from './statom.svg';
import unknown from './unknown.svg';
import osmosis from './osmosis.svg';
import sttia from './sttia.svg';
import stkdydx from './stkdydx.svg';
import stkatom from './stkatom.svg';

const icons: { [key: string]: string } = {
  atom,
  statom1: atom,
  statom,
  stosmo: osmosis,
  sttia,
  stkatom,
  stkdydx,
  unknown,
};

export default icons;
